/**
 * Created by Rakesh Peela
 * Date: 25-Dec-2019
 * Time: 1:13 PM
 */
import React from 'react';
import debounce from 'lodash/debounce';
import {IconButton, Typography, withStyles} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {capitalizeEachWord} from "../../../../../../../../../../../utils";
import {INAPP_LAYOUT_TYPES} from "../../models/common";
import {ButtonGroup, DEFAULT_IMAGE_SIZE_TYPES} from "../../utils";
import ExpansionModuleConfig from "../ExpansionModuleConfig";
import ModuleConfigSection from "./ModuleConfigSection";
import ActionsTextField from "../ActionsTextField";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => {
};

const styles_ImagePreview = (theme) => ({
    hoverContainer: {
        alignItems: "center",
        backgroundColor: "transparent",
        border: 0,
        borderRadius: 4,
        cursor: "pointer",
        display: "inline-flex",
        justifyContent: "center",
        outline: "none",
        padding: 0,
        position: "relative",
        textAlign: "initial",
        textDecoration: "none",
        userSelect: "none",
        verticalAlign: "middle",
        marginRight: 4,
        "&:hover $overlayDiv": {
            background: "rgba(100,100,100,0.9)",
            display: "flex",
        }
    },
    overlayDiv: {
        alignItems: "center",
        border: "8px solid transparent",
        borderRadius: 4,
        borderStyle: "inset",
        display: "none",
        height: "100%",
        justifyContent: "center",
        left: 0,
        position: "absolute",
        textAlign: "center",
        top: 0,
        transition: "display 0.2s ease-in-out",
        width: "100%",
        zIndex: 999,
    }
});

class ImagePreview extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {config, classes, clearCurrentImage, defaultImage} = this.props;
        return (
            <div className={classes.hoverContainer}>
                <img src={"data:image/png;base64," + config} alt={"image_preview"}
                     style={{
                         width: 128,
                         height: 128,
                         backgroundImage: "linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%)",
                         backgroundSize: "20px 20px",
                         backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
                     }}/>
                {!defaultImage && <div className={classes.overlayDiv}>
                    <IconButton
                        onClick={clearCurrentImage}
                        style={{
                            background: "#fff",
                            boxShadow: "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)",
                        }}>
                        <CloseIcon fontSize={"small"} color={"error"}/>
                    </IconButton>
                </div>}
            </div>
        );
    }
}

let StyledImagePreview = withStyles(styles_ImagePreview)(ImagePreview);

class ImageUploader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <input accept="image/jpeg, image/png"
                       type={"file"}
                       multiple={false}
                       onChange={(e) => {
                           this.props.handleImageChange(e.target.files)
                       }}/>

                <Typography variant={"subtitle2"}>
                    <span style={{fontWeight: 600}}> Note: </span> Max image dimensions - 128x128 pixels
                </Typography>
            </div>
        );
    }
}

class Image_Config extends React.Component {
    constructor(props) {
        super(props);
        this.default_image = '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';
        this.state = {
            localImage: this.props.config,
            error: false,
            default: this.props.config === this.default_image
        };

        this.debounce = debounce((fn, data, stepIndex) => {
            stepIndex ? fn(data, stepIndex) : fn(data)
        }, 300);
    }

    handleImageChange = (imagesList) => {
        const {message, onChange, currentCampaignStep, isPure} = this.props;
        if (imagesList.length > 0) {
            let reader = new FileReader();
            reader.onload = (readerEvent) => {
                let imageObj = new Image();
                imageObj.onload = (imageEvent) => {
                    let canvas = document.createElement('canvas'),
                        max_size = 128,
                        width = imageObj.width,
                        height = imageObj.height;
                    if (width > height) {
                        if (width > max_size) {
                            height *= max_size / width;
                            width = max_size;
                        }
                    } else {
                        if (height > max_size) {
                            width *= max_size / height;
                            height = max_size;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(imageObj, 0, 0, width, height);
                    let dataUrl = canvas.toDataURL('image/png');
                    dataUrl = dataUrl.slice(22);
                    this.setState({
                        localImage: dataUrl,
                        default: false
                    }, () => {
                        if (isPure) {
                            this.debounce(onChange, dataUrl);
                        } else {
                            this.debounce(onChange, {...message, image: dataUrl}, currentCampaignStep);
                        }
                    });
                };
                imageObj.src = readerEvent.target.result;
            };

            reader.readAsDataURL(imagesList[0]);

            reader.onerror = () => {
                this.setState({
                    error: true,
                })
            };
        }
    };

    clearCurrentImage = () => {
        const {message, onChange, currentCampaignStep, isPure = false} = this.props;
        this.setState({
            localImage: this.default_image,
            default: true
        });
        if (isPure) {
            onChange(this.default_image)
        } else {
            this.debounce(onChange, {...message, image: this.default_image}, currentCampaignStep)
        }
    };

    onImageURLChange = (e) => {
        const {isPure, onChange, currentCampaignStep, message} = this.props;

        this.setState({
            localImage: e.target.value,
            default: false
        }, () => {
            if (isPure) {
                this.debounce(onChange, this.state.localImage);
            } else {
                this.debounce(onChange, {...message, image: this.state.localImage}, currentCampaignStep);
            }
        });
    };

    handleOnImageSizeChange = (imageSize) => {
        const {onChange, currentCampaignStep, message} = this.props;
        this.debounce(onChange, {...message, image_size: imageSize}, currentCampaignStep);
    };

    render() {
        const {localImage, error} = this.state;
        const {isPure, message = {}} = this.props;
        const {type = "IN_LINE", layout_type = ""} = message;

        let element;

        if (type !== "IN_APP") {
            element = (
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: isPure ? "6px 0" : 0
                }}>
                    <StyledImagePreview defaultImage={this.state.default} config={localImage}
                                        clearCurrentImage={this.clearCurrentImage}/>
                    <div style={{padding: 12}}>
                        <ImageUploader localImage={localImage} handleImageChange={this.handleImageChange}/>
                        {error && <Typography variant={"subtitle2"} color={"error"}>
                            Error loading Image file
                        </Typography>}
                    </div>
                </div>
            );
        } else {
            // For InApp, we take Image only in URL format
            element = (
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: isPure ? "6px 0" : 0
                }}>
                    <Grid container>
                        <Grid item xs={10} md={10} sm={10}>
                            <ModuleConfigSection title={"Background Image"}>
                                <ActionsTextField
                                    style={{marginBottom: 0}}
                                    placeholder={"https://image_url"}
                                    value={localImage}
                                    onChange={this.onImageURLChange}
                                />
                            </ModuleConfigSection>
                        </Grid>
                        {
                            layout_type
                            && layout_type === INAPP_LAYOUT_TYPES.FULL_SCREEN_MODAL
                            && <Grid item xs={10} md={10} sm={10}>
                                <ModuleConfigSection
                                    title={"Image Size"}>
                                    <ButtonGroup buttons={DEFAULT_IMAGE_SIZE_TYPES}
                                                 selectedIndex={DEFAULT_IMAGE_SIZE_TYPES.indexOf(capitalizeEachWord(message.image_size))}
                                                 onButtonSelected={(index) => this.handleOnImageSizeChange(DEFAULT_IMAGE_SIZE_TYPES[index], 'image_size')}/>
                                </ModuleConfigSection>
                            </Grid>
                        }
                    </Grid>
                </div>
            );
        }

        return isPure ? element :
            (<ExpansionModuleConfig defaultExpanded title={"Image Configuration"}>{element}</ExpansionModuleConfig>);
    }
}

export default withStyles(styles)(Image_Config)